<app-add-commentaire [id_opportunite]="id_opportunite" [allowed_to_update]="allowed_to_update" [fromType]="'O'"></app-add-commentaire>